import GaxonIcon from './components/GaxonIcon'

export default GaxonIcon
